var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticStyle: { border: "1px solid #ccc", "margin-top": "10px" } },
      [
        _c("Toolbar", {
          ref: "toolbar",
          staticStyle: { "border-bottom": "1px solid #ccc" },
          attrs: { editor: _vm.editor, defaultConfig: _vm.toolbarConfig }
        }),
        _vm._v(" "),
        _c("Editor", {
          ref: "editor",
          staticStyle: { height: "400px" },
          attrs: { defaultConfig: _vm.editorConfig },
          on: {
            onChange: _vm.onChange,
            onCreated: _vm.onCreated,
            customPaste: _vm.customPaste,
            onBlur: function($event) {
              return _vm.$emit("blur")
            }
          },
          model: {
            value: _vm.html,
            callback: function($$v) {
              _vm.html = $$v
            },
            expression: "html"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d12a100", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d12a100","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my_editor.vue
// module id = null
// module chunks = 